import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';

const ConditionsComponent = () => {
  const [fontSize, setFontSize] = useState('1rem');
  const [titleSize, setTitleSize] = useState('1.2rem');
  const [imgWidth, setImgWidth] = useState('11rem');

  useEffect(() => {
    const updateSizes = () => {
      const w = window.innerWidth;
      if (w < 400) {
        setFontSize('0.38rem');
        setTitleSize('0.65rem');
        setImgWidth('28%');
      } else if (w < 500) {
        setFontSize('0.45rem');
        setTitleSize('0.75rem');
        setImgWidth('30%');
      } else if (w < 600) {
        setFontSize('0.60rem');
        setTitleSize('0.9rem');
        setImgWidth('31%');
      } else if (w < 700) {
        setFontSize('0.68rem');
        setTitleSize('1rem');
        setImgWidth('32%');
      } else {
        setFontSize('0.75rem');
        setTitleSize('1.2rem');
        setImgWidth('11rem');
      }
    };

    updateSizes();
    window.addEventListener('resize', updateSizes);
    return () => window.removeEventListener('resize', updateSizes);
  }, []);

  const sharedBoxStyle = {
    backgroundColor: 'rgba(32, 32, 32, 0.55)',
    borderRadius: '30px',
    boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.2)',
    color: 'white',
    fontFamily: 'Noto Sans, sans-serif',
  };

  const conditions = [
    'Back and neck pain',
    'Joint pain and stiffness',
    'Headaches',
    'Migraines, vertigo, tinnitus',
    'TMJ (jaw pain)',
    'Sciatica',
    'Asthma',
    'Concussion',
    'Benign Prostatic Hyperplasia (BPH)',
    'Pelvic floor pain and dysfunction',
    'Pregnancy-related discomfort',
    'Newborn and pediatric conditions (e.g. colic, feeding or latching difficulties, ear infections, plagiocephaly, torticollis)',
    'Rheumatologic and connective tissue disorders (Ehlers-Danlos Syndrome (EDS), fibromyalgia, lupus)',
    'Gymnastics, dance, and sports injuries',
    'Recovery from injuries or surgery',
    'Stress-related tension and fatigue',
    'Scoliosis',
  ];
  

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', px: 2, py: 3 }}>
      <Box
        sx={{
          ...sharedBoxStyle,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'stretch',
          padding: 2,
          gap: 2,
          maxWidth: '1100px',
          width: '100%',
        }}
      >
        {/* Image with enforced 2:3 aspect ratio */}
        <Box
          sx={{
            width: imgWidth,
            position: 'relative',
            flexShrink: 0,
            borderRadius: '6px',
            overflow: 'hidden',
            '&::before': {
              content: '""',
              display: 'block',
              paddingTop: '150%',
            },
          }}
        >
          <Box
            component="img"
            src="/images/conditions.png"
            alt="Osteopathic care for back pain, joint pain, headaches, and other conditions"
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        </Box>

        {/* Text */}
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', pr: 1 }}>
          <Typography
            component="h2"
            variant="h5"
            sx={{ fontWeight: 'bold', fontSize: titleSize, mb: 0 }}
          >
            Conditions I Treat
          </Typography>

          <Typography
            sx={{
              fontSize,
              lineHeight: 1.5,
              textAlign: 'left',
              mb: 1,
            }}
          >
            I use Osteopathic Manipulative Medicine to help patients with a wide range of conditions, including:
          </Typography>

          <Box component="ul" sx={{ pl: 2, mb: 1, flexGrow: 1 }}>
            {conditions.map((condition, index) => (
              <Typography
                component="li"
                key={index}
                sx={{
                  fontSize,
                  lineHeight: 1.5,
                  mb: 0.1,
                }}
              >
                {condition}
              </Typography>
            ))}
          </Box>

          <Typography sx={{ fontSize, lineHeight: 1.5, textAlign: 'left' }}>
            Every patient is different — treatment is always tailored to your specific needs and comfort level.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ConditionsComponent;
